<template>
	<el-card class="guest-container">
		<template #header>
			<div class="header" style="display: flex;justify-content: space-between;">
				<Search v-on:inputValue="inputValue" />
				<!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="addRole('')">新增</el-button> -->
				<!-- <el-button type="danger" size="small" icon="el-icon-delete" @click="">删除</el-button> -->

			</div>
			<div class="export">
				<el-date-picker
				      v-model="exportExcel.start_time"
				      type="datetime"
				      placeholder="开始日期">
				</el-date-picker>
				<el-date-picker
				      v-model="exportExcel.end_time"
				      type="datetime"
				      placeholder="结束日期">
				</el-date-picker>
				<el-select v-model="exportExcel.order_status" placeholder="请选择状态" clearable>
					<el-option v-for="item in getOrderStatusData" :key="item.order_status_name_cn" :label="item.order_status_name_cn" :value="item.id"></el-option>
				</el-select>
				<div>
					<el-button type="warning" @click="export">订单导出</el-button>
				</div>
			</div>
		</template>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane v-for="(item,index) in tabList" :key="index" :label="item" :name="index">
				<el-table v-if="index === activeName" :data="tableData.data" v-loading="loading">
					<el-table-column label="订单编号" prop="id"></el-table-column>
					<el-table-column label="商品信息" min-width="320">
						<template v-slot="scope">
							<div style="display: flex;flex-direction: column;">
								<div>
									<p>订单号:{{scope.row.order_num}}</p>
									<p>创建日期:{{scope.row.created_at}}</p>
								</div>
								<div style="display: flex;flex-direction: row;margin-top: 10px!important;" v-for="(item,index) in scope.row.order_product" :key='index'>
									<div>
										<el-image class="product-img-small" :src="this.getImgPrefix()+scope.row.order_product[index].image"
										 fit="contain" lazy>
										</el-image>
									</div>
									<div style="padding: 0 50px 0 20px;min-width: 405px;">
										<p>
											<span>
												{{scope.row.order_product[index].product_name}}
											</span>
										</p>
										<p>
											<span>
												{{scope.row.order_product[index].product_model}}
											</span>
										</p>
										<p style="display: inline-block;font-size: 13px;color: #909399;" v-for="(i,k) in scope.row.order_product[index].order_product_attributes" :key='k'>
											{{i.key}}:{{i.value}}&nbsp;&nbsp;
										</p>
									</div>
								</div>
							</div>

						</template>
					</el-table-column>
					<el-table-column label="订单金额" min-width="120">
						<template v-slot="scope">
							<div>
								<!-- <p v-for="(item,index) in scope.row.order_total">{{item.title}}：{{item.text}}</p> -->
								<p>总计：{{scope.row.total}}</p>
								
							</div>
						</template>
					</el-table-column>
					<el-table-column label="买家" min-width="130">
						<template v-slot="scope">
							<div class="order-text">
								<p>
									<div style="display: flex;">
										<div>{{scope.row.customer.last_name}}{{scope.row.customer.first_name}}</div>
										
										<el-image v-if="scope.row.customer.image" :src='this.getImgPrefix()+scope.row.customer.vip_grade.image' :title="scope.row.customer.vip_grade.vip_name" :alt="scope.row.customer.vip_grade.vip_name" style='width: 15px;' fit='contain' ></el-image>
									</div>
								</p>
								<p>
									<el-tooltip placement="top">
										<template #content>
											<p>姓名:{{scope.row.order_address.customer_name}}</p>
											<p>手机:{{scope.row.order_address.phone}}</p>
											<p>地址:
												{{scope.row.order_address.street}}&nbsp;
												{{scope.row.order_address.zone}}&nbsp;
												{{scope.row.order_address.place_name}}&nbsp;
												{{scope.row.order_address.city_name}}&nbsp;
												{{scope.row.order_address.province_name}}&nbsp;
											</p>
											<p>邮编:{{scope.row.order_address.postcode}}</p>
										</template>
										<i class="el-icon-house"></i>
									</el-tooltip>
									<el-tooltip v-if="scope.row.comments" :content="scope.row.comments" placement="top">
										<i class="el-icon-chat-dot-round cs-ml-10" />
									</el-tooltip>
								</p>

							</div>
						</template>
					</el-table-column>
					<el-table-column v-if="activeName !=6" label="购买次数" prop="count">
					</el-table-column>
					<el-table-column label="付款方式" prop="pay_method">
						<template v-slot="scope">
							<span v-if="scope.row.pay_method ==0">未选择支付方式</span>
							<span v-if="scope.row.pay_method ==1">Visa</span>
							<span v-if="scope.row.pay_method ==2">Master</span>
							<span v-if="scope.row.pay_method ==3">JCB</span>
							<span v-if="scope.row.pay_method ==4">Diners</span>
							<span v-if="scope.row.pay_method ==5">AE</span>
							<span v-if="scope.row.pay_method ==6">银行转账</span>
						</template>
					</el-table-column>
					<el-table-column label="交易状态">
						<template v-slot="scope">
							<span v-if="scope.row.order_status ==1">等待买家付款</span>
							<span v-if="scope.row.order_status ==2">买家已付款</span>
							<span v-if="scope.row.order_status ==3">未发货</span>
							<span v-if="scope.row.order_status ==4">交易成功</span>
							<span v-if="scope.row.order_status ==5">已退款</span>
							<span v-if="scope.row.order_status ==6" style="color: red;">已撤销</span>
							<p style="cursor: pointer;color: skyblue;" @click="handleInfo(scope.row)">
								详情
							</p>
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作">
						<template v-slot="scope">
							<div class="order-text">
								<p v-if="scope.row.order_status >=2 && scope.row.order_status <5" @click="refund(scope.row)" style="color: #e6a23c;cursor: pointer;">
									退款
								</p>	
								<p v-if="scope.row.order_status >=5" @click="delOrder(scope.row)" style="cursor: pointer;color: red;">
									删除订单
								</p>
								<p v-else @click="delOrder(scope.row)" style="cursor: pointer;color: red;">
									撤销订单
								</p>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<pages :total="total" :pageSize="pageSize" @handleSizeChangeSub="handleSizeChangeFun" @handleCurrentChangeSub="handleCurrentChangeFun"></pages>
			</el-tab-pane>
		</el-tabs>
	</el-card>
</template>

<script>
	import Search from '../common/Search.vue'
	import pages from '../common/Pagination.vue'
	export default {
		inject: ["reload"],
		name: 'OrderList',
		components: {
			pages,
			Search
		},
		data() {
			return {
				total: 0,
				currentPage: 1,
				pageSize: 10,
				activeName: '0',
				tabList: {
					0: '全部',
					1: '未付款',
					2: '已付款',
					3: '未发货',
					4: '已发货',
					5: '已退款',
					6: '撤销订单',
				},
				tableData: [],
				getOrderStatusData:[],
				list: [],
				exportExcel:{
					start_time:'',
					end_time:'',
					order_status:''
				},
				searchConditions:{},
				loading: false,
			}
		},
		methods: {
			export(){
				this.httpPost({
					url: '/admin/order/orderExport',
					data:this.exportExcel,
				}).then((res) => {
					console.log(this.webHost()+"/orderExport/"+res.data)
					window.open(this.webHost()+"/orderExport/"+res.data);	
				})

			},
			getOrderStatus(){
				this.httpPost({
					url: '/admin/common/getOrderStatus',
				}).then((res) => {
					this.getOrderStatusData = res.data;
				})
			},
			inputValue(inpVal) {
				// console.log(inpVal)
				// // this.activeName = '0'
				// this.loading = true;
				// this.httpPost({
				// 	url: '/admin/order/order_list',
				// 	data: {
				// 		keywords: inpVal,
				// 		p: this.currentPage,
				// 		tab:this.activeName,
				// 	}
				// }).then((res) => {
				// 	this.tableData = res.data;
				// 	this.total = res.data.total;
				// 	this.currentPage = res.data.currentPage;
				// 	this.loading = false;
				// })
				this.searchConditions=inpVal;
				this.getOrderList();
			},
			handleSizeChangeFun(page) {
				// this.pageSize = page;
				// this.getOrderList();
			},
			handleCurrentChangeFun(page) {
				// console.log(page)
				this.currentPage = page;
				// let str = '';
				// str = this.$route.path + '?p=' + page;
				// this.$router.push(str);
				this.getOrderList();
			},
			getOrderList() {
				// console.log(this.activeName);
				this.loading = true
				let searchConditionsData = [];
				if(this.searchConditions.keywords !=''||this.searchConditions.p !=''||this.searchConditions.tab !=''){
					searchConditionsData = this.searchConditions
				}
				console.log(searchConditionsData);
				this.httpPost({
					url: '/admin/order/order_list',
					data: {
						keywords: searchConditionsData,
						p: this.currentPage,
						tab:this.activeName,
						routePath: this.$route.path
					}
				}).then((res) => {
					this.tableData = res.data;
					console.log(this.tableData);
					this.total = res.data.total;
					this.loading = false;
				})
			},
			delOrder(val) {
				let order_id = val.id;
				let order_status = 6;
				this.msgBoxAjax(
					'提示',
					'确定删除吗？',
					"/admin/order/delOrder", {
						order_id: order_id,
						order_status: order_status
					}).then((res) => {
					// console.log(data);

					if (res.code == 1) {
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {

							this.$router.go(0);
						});
					} else {

						this.messageCommon('错误', res.msg, 'error');
					}
				});
			},
			handleInfo(val) {
				this.$router.push({
					path: '/main/order_info',
					query: {
						id: val.id,
					}
				})
				// let routeData = this.$router.resolve({ path: '/main/order_info' ,query: {
				// 		id: val.id,
				// 	}});
				// window.open(routeData.href, '_blank');
			},
			// modifyOrder(val) {
			// 	this.form.id = val.order_address.id;
			// 	this.form.customer_name = val.order_address.customer_name;
			// 	this.form.phone = val.order_address.phone;
			// 	this.form.street = val.order_address.street;
			// 	this.form.state_id = [val.order_address.province_id, val.order_address.city_id]
			// 	this.form.postcode = val.order_address.postcode;

			// 	this.dialogFormVisible = true;
			// },
			refund(val){
				let order_id = val.id;
				let order_status = 5;
				this.msgBoxAjax(
					'提示',
					'确定要退款吗？',
					"/admin/order/refund", {
						order_id: order_id,
						order_status: order_status
					}).then((res) => {
					// console.log(data);
				
					if (res.code == 1) {
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
				
							this.$router.go(0);
						});
					} else {
				
						this.messageCommon('错误', res.msg, 'error');
					}
				});
			},
			handleClick(tab, event) {
				this.loading = true
				let lab = tab.index ? tab.index : 0;
				this.httpPost({
					url: '/admin/order/order_list',
					data: {
						tab: lab
					}
				}).then((res) => {
					this.tableData = res.data;
					this.loading = false;
					this.total = res.data.total;
				})
			},
			
			submit() {
				this.httpPost({
					url: '/admin/order/modify_order',
					data: {
						form: this.form
					}
				}).then((res) => {
					if (res.code == 1) {
						this.dialogFormVisible = false;
						this.$message.success(res.msg);
						this.loading = false;
						this.getOrderList();
					}
				})
			}
		},
		created() {
			this.getOrderList();
			this.getOrderStatus();
			this.httpPost({
				url: '/admin/common/getState'
			}).then((res) => {
				this.options = res.data;
			})
		}
	}
</script>

<style>
	.guest-container {
		min-height: 100%;
	}

	.product-img-small {
		float: left;
		width: 80px;
		height: 80px;
	}

	.order-text>p {
		margin: 0;
	}

	.order-button {
		padding: 0;
		font-size: 13px;
	}
	.export{
		display: flex;
	}
	.export>div{
		margin-left: 10px;
	}
</style>
